import { captureMessage } from '@sentry/angular';
import { logger } from '@damofire/data-commons';
import { clone } from 'lodash-es';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContext, WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { getErrorMessage } from './steps-utils';

export class WarehouseSyncStepTaskExecutor {
  async executeStepTask(
    task: WarehouseSyncStepTask,
    taskInx: number,
    ctx: WarehouseSyncStepContext,
    listener: Observer<WarehouseSyncStepContextEvent>,
    taskBreaker: Subject<boolean>,
  ): Promise<WarehouseSyncStepTaskContext> {
    const when = new Date().getTime();
    const taskCtx: WarehouseSyncStepTaskContext = {
      _id: `${when}`,
      syncId: ctx.syncId,
      step: ctx.step,
      task: ctx.task,
      division: ctx.division,
      progress: 0,
      status: 'RUNNING',
      when,
      taskInx,
    };

    try {
      listener.next({ ctx: clone(taskCtx), event: 'TASK_STARTED' });
      await task.execute(taskCtx, listener, taskBreaker);
      taskCtx.when = new Date().getTime();
      listener.next({ ctx: clone(taskCtx), event: 'TASK_FINISHED' });
      taskCtx.status = 'DONE';
    } catch (err) {
      logger.error('Task could not be completed', { category: 'sync', task: task.name() });
      captureMessage(`Task could not be completed.`, {
        level: 'error',
        extra: { err: err || 'no error object', task: task.name() },
      });
      taskCtx.status = 'ERROR';
      taskCtx.when = new Date().getTime();
      listener.next({ ctx: clone(taskCtx), event: 'TASK_ERROR', err: getErrorMessage(err) });
    }

    return taskCtx;
  }
}
